var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M56,30H44v-8h12V30z M98,36c-1.2-4.3-3-8.3-5.3-12H75.9C74.9,10.6,63.7,0,50,0S25.1,10.6,24.1,24H7.3 C5,27.7,3.2,31.7,2,36c-1.3,4.4-2,9.1-2,14c0,27.6,22.4,50,50,50s50-22.4,50-50C100,45.1,99.3,40.4,98,36z M50,92 C26.8,92,8,73.2,8,50c0-4.9,0.8-9.6,2.4-14H35c-1.9-2.9-3-6.3-3-10c0-0.7,0-1.3,0.1-2c1-9,8.6-16,17.9-16s16.9,7,17.9,16 c0.1,0.7,0.1,1.3,0.1,2c0,3.7-1.1,7.1-3,10h24.6c1.6,4.4,2.4,9.1,2.4,14C92,73.2,73.2,92,50,92z M80,49H20v8h60V49z M68,67H32v8h36 V67z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon03);
export default __webpack_public_path__ + "static/media/motion_icon-03.921d6c81.svg";
export { ForwardRef as ReactComponent };